import {FC} from 'react';
import {useRecoilValueLoadable} from 'recoil';
import {Avatar, Stack, Typography} from '@mui/material';
import {IUserAccount} from '../../../shared/types/user-account.types';
import {getFullName} from '../../../shared/helpers/getFullName';
import {userAccountPhotoQueryFamily} from '../../../store/users/selectors';

interface Props {
  row: IUserAccount;
}

export const UserNameWithAvatar: FC<Props> = ({row}) => {
  const {contents} = useRecoilValueLoadable(userAccountPhotoQueryFamily(row.photo ? row.id : 0));

  return (
    <Stack direction="row" spacing={1} sx={{alignItems: 'center', height: '100%'}}>
      <Avatar sx={{width: 32, height: 32}} src={contents || ''} />
      <Typography variant="subtitle2">{getFullName(row)}</Typography>
    </Stack>
  );
};
